/**
 * HTTP Status Codes and their user-friendly German translations
 */

/**
 * Map of HTTP status codes to user-friendly German names
 */
const HTTP_STATUS_NAMES: Record<number, string> = {
  400: 'Ungültige Anfrage', // Bad Request
  401: 'Nicht authentifiziert', // Unauthorized
  403: 'Zugriff verweigert', // Forbidden
  404: 'Nicht gefunden', // Not Found
  408: 'Zeitüberschreitung', // Request Timeout
  409: 'Konflikt', // Conflict
  422: 'Ungültige Daten', // Unprocessable Entity
  429: 'Zu viele Anfragen', // Too Many Requests
  500: 'Serverfehler', // Internal Server Error
  502: 'Gateway-Fehler', // Bad Gateway
  503: 'Dienst nicht verfügbar', // Service Unavailable
  504: 'Gateway-Zeitüberschreitung', // Gateway Timeout
}

/**
 * Get a user-friendly German name for an HTTP status code
 *
 * @param statusCode - The HTTP status code
 * @returns A user-friendly German name for the status code, or a generic error message if not found
 *
 * @example
 * getHttpStatusName(401) // returns "Nicht authentifiziert"
 * getHttpStatusName(404) // returns "Nicht gefunden"
 * getHttpStatusName(999) // returns "Fehler 999"
 */
export const getHttpStatusName = (statusCode: number): string => {
  return HTTP_STATUS_NAMES[statusCode] || `Fehler ${statusCode}`
}
